// Supermove
import {gql} from '@supermove/graphql';
import {Form} from '@supermove/hooks';
import {ProjectTypeModel, ProjectType} from '@supermove/models';
import {withFragment} from '@supermove/utils';

// App
import ProjectTypeFeatureForm, {
  ProjectTypeFeatureFormFieldsType,
} from '@shared/modules/Project/forms/ProjectTypeFeatureForm';

type DefaultProjectTypeInventorySettingsFormFieldsType = {
  projectTypeId: string;
  inventoryLibraryId: number;
  surveyMethodId: number;
  // Note(Hammad) this projectTypeFeatureForm is for TAX_SURVEY_ITEMS
  projectTypeFeatureForm?: ProjectTypeFeatureFormFieldsType;
  // private
  projectTypeName: string;
  projectTypeColor: string;
};

export type DefaultProjectTypeInventorySettingsFormType = Form<{
  defaultProjectTypeInventorySettingsForm: DefaultProjectTypeInventorySettingsFormFieldsType;
}>;

type DefaultProjectTypeInventorySettingsFormToMutationType = {
  projectTypeId: string;
  inventoryLibraryId: number;
  surveyMethodId: number;
  projectTypeFeatureForm?: ProjectTypeFeatureFormFieldsType;
};

const _new = ({
  projectTypeId,
  projectTypeName = '',
  projectTypeColor = '',
}: {
  projectTypeId: string;
  projectTypeName: string;
  projectTypeColor: string;
}) => ({
  projectTypeId,
  inventoryLibraryId: null,
  surveyMethodId: null,

  // private
  projectTypeName,
  projectTypeColor,
});

const edit = withFragment(
  (projectType: ProjectTypeModel) => ({
    projectTypeId: projectType.id,
    inventoryLibraryId: projectType.defaultInventoryLibraryId,
    surveyMethodId: projectType.defaultSurveyMethodId,
    projectTypeFeatureForm: ProjectTypeFeatureForm.new({
      projectTypeId: projectType.id,
      feature: ProjectType.FEATURES.TAX_SURVEY_ITEMS,
      isEnabled: projectType.features.taxSurveyItems,
    }),
    // private
    projectTypeName: projectType.name,
    projectTypeColor: projectType.color,
  }),
  gql`
    fragment DefaultProjectTypeInventorySettingsForm_edit on ProjectType {
      id
      name
      color
      defaultInventoryLibraryId
      defaultSurveyMethodId
      features {
        taxSurveyItems
      }
    }
  `,
);

const toForm = ({
  projectTypeId,
  inventoryLibraryId,
  surveyMethodId,
  projectTypeFeatureForm,
  projectTypeName,
  projectTypeColor,
}: DefaultProjectTypeInventorySettingsFormFieldsType) => ({
  projectTypeId,
  inventoryLibraryId,
  surveyMethodId,
  projectTypeFeatureForm: projectTypeFeatureForm
    ? ProjectTypeFeatureForm.toForm(projectTypeFeatureForm)
    : undefined,

  // private
  projectTypeName,
  projectTypeColor,
});

const toMutation = ({
  projectTypeId,
  inventoryLibraryId,
  surveyMethodId,
  projectTypeFeatureForm,
}: DefaultProjectTypeInventorySettingsFormToMutationType) => ({
  projectTypeId,
  inventoryLibraryId,
  surveyMethodId,
  projectTypeFeatureForm: projectTypeFeatureForm
    ? ProjectTypeFeatureForm.toMutation(projectTypeFeatureForm)
    : undefined,
});

const DefaultProjectTypeInventorySettingsForm = {
  new: _new,
  edit,
  toForm,
  toMutation,
};

export default DefaultProjectTypeInventorySettingsForm;
